import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Icon,
  Text,
  Th,
  Thead,
  Tr,
  Box,
  Grid,
  FormLabel,
  Select,
  Badge,
  Button,
  useToast,
  useEditableControls,
  ButtonGroup,
  IconButton,
  Editable,
  EditablePreview,
  EditableInput,
  Input,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Table Components

// Data
import { ordersTableData } from "variables/general";
import GradientBorder from "components/GradientBorder/GradientBorder";
import CustomDateInput from "components/CustomField/CustomDateInput";
import { useLoader } from "components/Loader/loader";
import TablesTableRow from "components/Tables/TablesTableRow";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { AiFillCloseCircle, AiFillRightCircle } from "react-icons/ai";
import useApiReq from "variables/apireq";
import { PagingControls } from "components/ui/pagination";
import { motion } from "framer-motion";

// Icons
import { FiEdit } from "react-icons/fi";
import { IoCodeSharp } from "react-icons/io5";
import { FaCheckCircle } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { MdClose, MdEdit } from "react-icons/md";
import { DeleteIcon } from "@chakra-ui/icons";

function OrderList() {
  const titleColor = "white";
  const toast = useToast({ position: "top" });

  const { setIsLoading, isLoading } = useLoader();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemcount, setItemCount] = useState(10);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(itemcount);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [type, setType] = useState();
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [modalIndex, setmodalIndex] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);

  const fetchOrders = async (data) => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "order/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: data,
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response.reverse());
        // console.log(res.response.reverse());
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOrderUpdate = async (row, data) => {
    setError(null);
    try {
      const res = await useApiReq({
        method: "PATCH",
        url: `order/update/${row.uuid}/`,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          discount: data,
        },
      });
      if (res.error) {
        setError(res.error);
      } else {
        setError(null);

        row.discount = data;

        toast({
          title: "Order Updated",
          description: "Order has been updated successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        fetchOrders();
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const text = (child) => {
    return (
      <Text fontSize="sm" color="#fff" fontWeight="normal">
        {child}
      </Text>
    );
  };

  const badge = (child) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
        }}
      >
        <Badge
          borderRadius="10px"
          px="2"
          colorScheme="teal"
          color="white"
          variant="solid"
          h={{ base: "20px", md: "30px" }}
          fontSize={{ base: "sm", md: "md" }}
          textAlign="center"
          py={{ base: "4px", md: "4px" }}
        >
          {child}
        </Badge>
      </div>
    );
  };

  const edit = () => {
    return (
      <Button p="0px" bg="transparent" _hover="none" _active="none">
        <Icon as={FiEdit} color="gray.400" cursor="pointer" />
      </Button>
    );
  };

  const tag = (index) => {
    return (
      <Button
        p="0px"
        bg="transparent"
        _hover="none"
        _active="none"
        onClick={() => ChnageOpen(index)}
      >
        <Icon as={IoCodeSharp} color="gray.400" cursor="pointer" />
      </Button>
    );
  };

  const btn = (text, onclick, disabled = false) => {
    return (
      <Button
        p="2px 10px"
        bg="brand.20"
        borderRadius="4px"
        variant="no-hover"
        onClick={onclick}
        textColor={"gray.400"}
        _hover={{ bg: "#0099a2", color: "#fff", textColor: "#fff" }}
        disabled={disabled}
        cursor="pointer"
      >
        <Text fontSize="sm" fontWeight="bold">
          {text}
        </Text>
      </Button>
    );
  };

  const editableField = ({ text, onSubmit, disabled = false }) => {
    function EditableControls() {
      const {
        isEditing,
        getSubmitButtonProps,
        getCancelButtonProps,
        getEditButtonProps,
      } = useEditableControls();

      return isEditing ? (
        <ButtonGroup justifyContent="center" size="sm">
          <IconButton
            colorScheme="teal"
            icon={<FaCheck />}
            {...getSubmitButtonProps()}
          />
          <IconButton
            colorScheme="teal"
            icon={<MdClose />}
            {...getCancelButtonProps()}
          />
        </ButtonGroup>
      ) : (
        <Flex justifyContent="center">
          <IconButton
            colorScheme="teal"
            size="sm"
            icon={<MdEdit />}
            {...getEditButtonProps()}
          />
        </Flex>
      );
    }
    return (
      <Editable
        textAlign="center"
        defaultValue={text}
        fontSize="lg"
        isPreviewFocusable={false}
        onSubmit={onSubmit}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <EditablePreview />
        {/* Here is the custom input */}
        <Input maxWidth="100px" as={EditableInput} />
        <EditableControls />
      </Editable>
    );
  };

  const icon = ({ child, color, onclick = () => {} }, disabled = false) => {
    return (
      <Icon
        as={child}
        color={color}
        size={45}
        cursor={disabled ? "not-allowed" : "pointer"}
        opacity={disabled ? 0.5 : 1}
        onClick={disabled ? "null" : onclick}
      />
    );
  };

  useEffect(() => {
    if (
      startDate !== undefined &&
      endDate !== undefined &&
      type !== undefined
    ) {
      fetchOrders({
        start_date: startDate.toLocaleDateString(),
        end_date: endDate.toLocaleDateString(),
        type: type !== "both" ? [type] : ["analytics", "facebook"],
      });
    } else if (startDate !== undefined && endDate !== undefined) {
      fetchOrders({
        start_date: startDate.toLocaleDateString(),
        end_date: endDate.toLocaleDateString(),
      });
    } else if (type !== undefined) {
      fetchOrders({
        type: type !== "both" ? [type] : ["analytics", "facebook"],
      });
    } else {
      fetchOrders({});
    }
  }, [startDate, endDate, type]);

  const fetchOrderDelete = async (uuid) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "DELETE",
        url: `order/delete/${uuid}/`,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error);
      } else {
        setError(null);
        toast({
          title: "Order Deleted",
          description: "Order has been deleted successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        fetchOrders();
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getOptimalData = (row, index) => {
    const data = {};
    data["Order ID"] = text(index + 1);

    if (
      localStorage.getItem("group") === "Admin" ||
      localStorage.getItem("group") === "Publisher"
    ) {
      data["Order At"] = text(new Date(row.created_at).toLocaleDateString());
      data["Advertiser"] = text(row.advertiser_name);
    }
    data["PR Number"] = text(row.prnumber);
    data["Remaining PR Number"] = text(row.remaining_pr);

    data["PR Type"] = text(row.type);

    data["Package Price"] = text(row.price);
    data["Total Price"] = text(parseInt(row.price - row.discount));
    data["Unique Reach Per PR"] = text(row?.estimated_reader);
    data["Delete"] = icon(
      {
        child: DeleteIcon,
        color: "red.400",
        onclick: () => fetchOrderDelete(row.uuid),
      },
      row.paid || row.partial_payment_amount > 0
    );

    data["Discount"] = editableField({
      text: row.discount <= 0 ? row.discount : parseInt(row.discount),
      onSubmit: (value) => {
        fetchOrderUpdate(row, value);
      },
    });

    return data;
  };

  const getHeaders = () => {
    const headers = [];
    headers.push("Order ID");
    if (
      localStorage.getItem("group") === "Admin" ||
      localStorage.getItem("group") === "Publisher"
    ) {
      headers.push("Order At");
      headers.push("Advertiser");
    }
    headers.push("PR Number");
    headers.push("Remaining PR Number");
    headers.push("PR Type");
    headers.push("Package Price");
    headers.push("Total Price");
    headers.push("Unique Reach Per PR");
    headers.push("Delete");
    headers.push("Discount");
    return headers;
  };

  useEffect(() => {
    fetchOrders({});
  }, []);

  useEffect(() => {
    setStart((currentPage - 1) * itemcount);
    setEnd(currentPage * itemcount);
  }, [currentPage, itemcount]);

  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {/* Authors Table */}
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader p="6px 0px 22px 0px">
          <Box w="100%">
            <Text fontSize="lg" color="#fff" fontWeight="bold">
              Order History
            </Text>
            <Grid
              templateColumns={{
                sm: "1fr",
                md: "1fr 1fr",
                lg: "1fr 1fr 1fr",
              }}
              gap={6}
              minW={{ sm: "100%", md: "100%" }}
              w="100%"
              mt="24px"
            >
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Order Search From
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={startDate}
                    setSelectedDate={setStartDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Order Search To
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={endDate}
                    setSelectedDate={setEndDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Type
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <Select
                    color={titleColor}
                    bg={{
                      base: "rgb(19,21,54)",
                    }}
                    border="transparent"
                    borderRadius="20px"
                    fontSize="sm"
                    size="lg"
                    w={{ base: "100%", lg: "100%" }}
                    maxW="100%"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    h="46px"
                    type="text"
                    placeholder="Select Type"
                    name="type"
                    sx={{
                      option: {
                        backgroundColor: "rgb(19,21,54)",
                        color: "white",
                      },
                    }}
                  >
                    <option value="analytics">Analytics</option>
                    <option value="facebook">Facebook</option>
                    <option value="both">Both</option>
                  </Select>
                </GradientBorder>
              </Flex>
            </Grid>
          </Box>
        </CardHeader>
        <CardBody>
          <Table variant="simple" color="#fff">
            <Thead>
              <Tr my=".8rem" ps="0px" color="gray.400">
                {getHeaders().map((header) => {
                  return (
                    <Th
                      ps="0px"
                      color="gray.400"
                      fontFamily='"Oxygen",serif'
                      borderBottomColor="#56577A"
                      textAlign={"center"}
                    >
                      {header}
                    </Th>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody ps="0px">
              {data.slice(start, end).map((row, index, arr) => {
                return (
                  <TablesTableRow
                    data={getOptimalData(row, index)}
                    lastItem={index === arr?.length - 1}
                    setOpen={null}
                    isOpen={isOpen}
                    openIndex={modalIndex}
                    currentIndex={index}
                  />
                );
              })}
            </Tbody>
          </Table>
        </CardBody>
        {data
          .slice((currentPage - 1) * itemcount, currentPage * itemcount)
          .map((x) => (
            <Box bg={"transparent"} key={x.id}>
              {x.text}
            </Box>
          ))}
        <Flex justify="space-between" my=".5rem">
          <PagingControls
            currentPage={currentPage}
            onGoToPage={(newPageNumber) => setCurrentPage(newPageNumber)}
            pageSize={itemcount}
            totalCount={data?.length || 0}
            totalCountDescription={"campaigns"}
            showPageCount={true}
          />
          <Select
            w="80px"
            variant="outline"
            colorScheme="blackAlpha"
            bg="transparent"
            backgroundColor={"transparent"}
            backdropBlur={"10px"}
            textColor="white"
            borderColor="whiteAlpha.300"
            sx={{
              option: {
                backgroundColor: "rgb(19,21,54)",
                color: "white",
              },
            }}
            iconColor="white"
            onChange={(e) => {
              setItemCount(e.target.value);
            }}
            value={itemcount}
          >
            <option value="10" selected>
              10
            </option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>
        </Flex>
      </Card>
    </Flex>
  );
}

export default OrderList;
